
import { defineComponent } from "vue";
import { Engine } from "@/Engine/index";
import SideBar from "./SideBar.vue";

//import {Engine} from '../Engine/playground/glb_collision'
//import {Engine} from '../Engine/playground/waterMaterial'

export default defineComponent({
  name: "BabylonEntry",
  components: {
    SideBar,
  },
  data() {
    return {
      showSidebar: false,
    };
  },
  mounted() {
    const canvas = document.querySelector("canvas") as HTMLCanvasElement;
    let example = new Engine(canvas);
    const EmployeeWindow = window as any;
    EmployeeWindow.example = example;
    EmployeeWindow.switchSidebar = this.switchSidebar;
  },
  methods: {
    switchSidebar(bool:boolean){
        this.showSidebar = bool;
        console.log(this.showSidebar);
    }
  },
});
